import { NgIf } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DashboardOption } from 'src/app/models/dashboard-option';

declare function generateChart(elementId: string, data: any, type: string): any;

@Component({
  selector: 'app-pie-chart',
  imports: [NgIf],
  templateUrl: './pie-chart.component.html',
  styleUrl: './pie-chart.component.css'
})
export class PieChartComponent {
  @Input() chartId!: string;
  @Input() icon!: string;
  @Input() title!: string; 
  @Input() data!: DashboardOption[]; 
  @Input() series: string[] = [];

  @Input() isLoading: boolean = false;  
  @Input() hasError: boolean = false;   
  @Input() isNoData: boolean = false;   

  private chartInstance: any; 

  colors: any = (window as any).chartColors; 
  colorHelper: any = (window as any).Chart.helpers.color; 

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['data']?.currentValue){
      this.buildChart();
    }
  }

  private buildChart(): void {
    if (!this.data || this.data.length === 0) return;

    const labelsList = this.data.map(item => item.labelName);
    const values = this.data.map(item => item.countValue);
  
  
    const pieChartData = {
      labels: labelsList,
      datasets: [{
        data: values,
        backgroundColor: labelsList.map((_, index) => this.colorHelper(this.colors[index]).alpha(0.5).rgbString()),
        borderColor: labelsList.map((_, index) => this.colors[index]),
        borderWidth: 1
      }]
    };
    const canvas = document.getElementById(this.chartId) as HTMLCanvasElement;
    if (canvas) {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      this.chartInstance = generateChart(this.chartId, pieChartData, 'pie');
    }
  }
 
}